<template>
  <div class="form-section">
    <div class="form-section-header">
      <h5 class="form-section-title">{{ title }}</h5>
      <!-- Slot para ações no cabeçalho -->
      <slot name="headerActions"></slot>
    </div>
    <div class="form-section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.form-section {
  margin-bottom: 0.5rem;
  padding: 0.75rem; /* Padding geral */
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.form-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem; /* Espaço reduzido abaixo do cabeçalho */
}


.form-section-title {
  font-size: 0.8rem; /* Fonte menor para o título */
  font-weight: 600;
  margin-bottom: 0.8rem; /* Espaço reduzido abaixo do título */
  color: #333;
}

.form-section-content {
  width: 100%;
  display: block; /* Pode ser flex, se necessário */
  line-height: 1.2; /* Reduz o espaçamento entre linhas */
}

/* Reduz o espaçamento entre os elementos internos (ex.: parágrafos) */
.form-section-content > * {
  margin-top: 0;
  margin-bottom: 0;
}

.form-control,
.form-select {
  padding: 0.25rem 0.5rem;
  font-size: 0.73rem;
  height: 25px;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  appearance: none;
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
}
</style>
